export default __webpack_public_path__ + "static/media/warning.86db2426.svg";